import config from "src/config";
import { ResponseDto } from "src/dtos/common/responseDto";
import { SalOrderDtlDto } from "src/dtos/salorder/salOrderDto";
import { getData } from "src/utils/axios/serverHelper";



const baseUrl = `${config.apiUrl}/SalesOrder`;

export const getSalOrderPopupList = async (searchText: string) => {
	return await getData<ResponseDto<SalOrderDtlDto[]>>(`${baseUrl}/detail/modal`, {
		params: { searchText }
		//   params: { searchText, itemCd }
	});
};
